import React from "react";
import { ProductSelectionState } from "types";

interface SelectedProductListProps {
    selectedProducts: ProductSelectionState;
}

export const SelectedProductList = ({ selectedProducts }: SelectedProductListProps) => {
    return (
        <div className="flex flex-col space-y-2">
            {selectedProducts.all ? (
                <div className="text-sm text-gray-dark">All products will be displayed</div>
            ) : (
                <div className="text-sm text-gray-dark">
                    <var data-var="selectedProductsCount">{selectedProducts.selected.length}</var> selected{" "}
                    {selectedProducts.selected.length === 1 ? "product" : "products"} will be displayed
                </div>
            )}
        </div>
    );
};
